import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'panel-admina',
    loadChildren: () => import('./admin-panel/admin-panel.routes').then(m => m.adminPanelRoutes),
  },
  {
    path: '',
    loadChildren: () => import('./client-app/client-app.routes').then(m => m.clientAppRoutes),
  },
];
